import React from 'react';

import Icon from 'components/atoms/Icon';
import Image from 'components/atoms/Image';
import mapModifiers from 'utils/functions';

export type ImageMessageItemTypes = {
  id: string,
  src: string,
  alt: string,
  status?: 'loading' | 'success' | 'error',
  handleClick?: () => void
};

interface ImageMessageProps {
  images: ImageMessageItemTypes[]
  isSended?: boolean
  isSmall?: boolean
  isShowRemove?: boolean
  onClick?: (url?: string) => void;
}

const ImageMessage: React.FC<ImageMessageProps> = ({
  images, isSended, isSmall, isShowRemove = true,
  onClick,
}) => (
  <div className={mapModifiers('m-imageMessage', isSended && 'sended', isSmall && 'small')}>
    {images.map((image) => (
      <div className="m-imageMessage_item" key={`image-message-item-${image.id}`}>
        <div className="m-imageMessage_wrapper">
          {
            isShowRemove && (
              <span className="m-imageMessage_close" onClick={image.handleClick}>
                <Icon iconName="whiteCircleClose" size={isSmall ? '16' : '18'} />
              </span>
            )
          }
          <Image
            src={image.src}
            alt={image.alt}
            ratio="1x1"
            onClick={() => {
              if (onClick) {
                onClick(image.src);
              }
            }}
          />
        </div>
      </div>
    ))}
  </div>
);

export default ImageMessage;
